import { map as m,path,filter as f, prop as p, compose as C,__,chain, last, ifElse, 
  isEmpty,always,apply,reject,isNil,gte,groupBy as g, indexBy,fromPairs,defaultTo,
} from "ramda"; 
import { weighted } from "./helpers";

const condition_inputs = C(
    reject(isNil),
    m(last),
    p("inputs")
  )

const conditional_show = email => x => {
  return [x.order_nr,
      x.condition === "yesNo" ? (Number(x.condition_input_data?.[0]?.value_number) === 1) :
      x.condition === "noYes" ? (Number(x.condition_input_data?.[0]?.value_number) === 0) :
      x.condition === "email" ? (x.condition_input_data?.[0]?.value_text === email) :
      x.condition === "veryPositive" ? (x.condition_avg >= 0.5) : 
      x.condition === "veryNegative" ? (x.condition_avg <= -0.5) : 
  false];
}

const condition_input_ranks = (x,obj) => C(
  m(C(p("order_nr"),p(__,obj))),
  condition_inputs
)(x)

const condition_avgs = data => C(
  weighted,
  chain(p(__,g(p("activity_id"),data))),
  condition_inputs
)

const condition_input_data = data => C(
  chain(p(__,g(p("activity_id"),data))),
  condition_inputs
)

const max_input_larger_than = done_nr => C(
    ifElse(isEmpty,always(false),C(gte(done_nr),apply(Math.max))),
    p("condition_ranks")
)

export const skip_list = (decision=[],data =[],session) => C(
    fromPairs,
    m(conditional_show(session.user.email)),
    f(max_input_larger_than(decision[0].show_until)),
    xs => m(x => ({...x,
      condition_input_data:condition_input_data(data)(x),
      condition_inputs: condition_inputs(x),
      condition_avg: condition_avgs(data)(x),
      condition_ranks:condition_input_ranks(x,indexBy(p("id"),xs))}),xs),
    chain(p("activities_with_types")),
    defaultTo([]),
    path([0,"decision_types","parts"])
  )(decision)